export const options = [
    {
        "id": "potencia",
        "name": "Potencia",
        "description": "0 - Cada verdura en su punto exacto, 10 - Unas más blandas, otras más al dente",
        "value": 2,
        "min": 1,
        "max": 3,
        "step": 1
    }
]